module.exports = __webpack_public_path__ + "assets/home-address-55e7b5.svg";